export default __webpack_public_path__ + "static/media/c_todo.ad023c98.png";